export enum UserEnrollmentStatus {
    None = "",
    New = "new",
    Progress = "progress",
    Completed = "completed",
    Failed = "failed",
    Skipped = "skipped"
}
